module.exports = __webpack_public_path__ + "static/img/crm.0f90f2d7.png";